import { computed } from 'vue';

export function useAmenityPricing({
                                      basePrice,
                                      offerPrice,
                                      mandatoryAmenities,
                                      optionalAmenities,
                                      selectedAmenities,
                                      selections,
                                      dateDays
                                  }) {

    const computeAmenityPrice = (amenity) => {
        if (!amenity.amenityUnit || !amenity.amenityUnit.computable) {
            return amenity.price;
        }

        const unit = amenity.amenityUnit.unitCategory?.name;

        switch (unit) {
            case 'Unit':
                return amenity.price;
            case 'People':
                return amenity.price * selections.value.persons;
            case 'Time':
                return (amenity.price / amenity.amenityUnit.ratio) * dateDays.value;
            case 'Time Person':
                return (
                    (amenity.price / amenity.amenityUnit.ratio) *
                    dateDays.value *
                    selections.value.persons
                );
            default:
                return amenity.price;
        }
    };

    const priceDetails = computed(() => {
        if (!offerPrice.value || offerPrice.value <= 0) {
            return {
                basePrice: 0,
                offerPrice: 0,
                hasOffer: false,
                total: 0,
                totalAdvanced: 0,
                totalOnSpot: 0,
                amenities: { advance: [], separate: [] }
            };
        }

        const selectedOptional = optionalAmenities.value.filter(a =>
            selectedAmenities.value.includes(Number(a.id))
        );
        
        const allAmenities = [
            ...mandatoryAmenities.value,
            ...selectedOptional
        ];

        const amenitiesResult = {
            advance: [],
            separate: []
        };

        let totalAdvanced = 0;
        let totalOnSpot = 0;

        allAmenities.forEach(amenity => {
            const subtotal = computeAmenityPrice(amenity);
            const target =
                amenity.paymentType === 'advance' || subtotal === 0
                    ? 'advance'
                    : 'separate';

            amenitiesResult[target].push({
                id: amenity.id,
                name:
                    amenity.name +
                    (amenity.amenityUnit?.uomName
                        ? ` / ${amenity.amenityUnit.uomName}`
                        : ''),
                subtotal
            });

            if (target === 'advance') totalAdvanced += subtotal;
            else totalOnSpot += subtotal;
        });

        return {
            basePrice: basePrice.value,
            offerPrice: offerPrice.value,
            hasOffer: basePrice.value !== offerPrice.value,
            total: offerPrice.value + totalAdvanced,
            totalAdvanced,
            totalOnSpot,
            amenities: amenitiesResult
        };
    });

    return { priceDetails };
}
